import React, { useEffect, useState } from 'react'
import useAuth from './useAuth'
import SpotifyWebApi from 'spotify-web-api-node'
import { Flex, Input, Stack, Text } from '@chakra-ui/react'
import TrackSearchResult from './TrackSearchResult'
import Player from './Player'
import axios from 'axios'

const spotifyApi = new SpotifyWebApi({
  clientId: process.env.REACT_APP_CLIENT_ID,
})

const API = process.env.REACT_APP_API

export default function Dashboard({ code }) {
  const [search, setSearch] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [playingTrack, setPlayingTrack] = useState()
  const [lyrics, setLyrics] = useState('')
  const accessToken = useAuth(code)

  function chooseTrack(track) {
    setPlayingTrack(track)
    setSearch('')
    setLyrics('')
  }

  useEffect(() => {
    if (!playingTrack) return

    axios
      .get(API + 'lyrics', {
        params: {
          track: playingTrack.title,
          artist: playingTrack.artist,
        },
      })
      .then((res) => {
        setLyrics(res.data.lyrics)
        console.log(res)
      })
  }, [playingTrack])

  useEffect(() => {
    if (!accessToken) return
    spotifyApi.setAccessToken(accessToken)
  }, [accessToken])

  useEffect(() => {
    if (!search) return setSearchResults([])
    if (!accessToken) return

    let cancel = false
    spotifyApi.searchTracks(search).then((res) => {
      if (cancel) return
      setSearchResults(
        res.body.tracks.items.map((track) => {
          const smallestAlbumImage = track.album.images.reduce(
            (smallest, image) => {
              if (image.height < smallest.height) return image
              return smallest
            },
            track.album.images[0]
          )
          return {
            artist: track.artists[0].name,
            title: track.name,
            uri: track.uri,
            albumUrl: smallestAlbumImage.url,
          }
        })
      )
    })
    return () => (cancel = true)
  }, [search, accessToken])

  return (
    <Flex
      direction="column"
      justifyContent="center"
      px={4}
      style={{ height: '100vh' }}
    >
      <Input
        size="sm"
        type="search"
        mt={2}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search Songs/Artists"
      />
      <Flex grow={1} justifyContent="center" style={{ overflowY: 'auto' }}>
        <Flex direction="column" m={2}>
          {searchResults.map((track) => (
            <TrackSearchResult
              track={track}
              key={track.uri}
              chooseTrack={chooseTrack}
            />
          ))}
          {searchResults.length === 0 && (
            <Stack textAlign="center" style={{ whiteSpace: 'pre' }}>
              <Text>{lyrics}</Text>
            </Stack>
          )}
        </Flex>
      </Flex>
      <Stack>
        <Player accessToken={accessToken} trackUri={playingTrack?.uri} />
      </Stack>
    </Flex>
  )
}
